import type { ReactNode } from 'react';

export const symbol_stacked_email: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-240q-24 0-42-18.5T160-300v-480q0-24 18-42t42-18h640q24 0 42 18t18 42v480q0 23-18 41.5T860-240H220Zm301-216L220-706v406h640v-406L559-456q-8 7-19 7t-19-7Zm19-63 315-261H225l315 261ZM100-120q-24 0-42-18.5T40-180v-529q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v529h690q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H100Zm760-586v-74H220v74-74h640v74Z"
		/>
	</svg>
);
